// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemVariables.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var constants = require('logic/data/Izenda.ReportSubscriptionConstants').SYSTEM_VARIABLES;

  var Label = require('share/components/controls/Izenda.Label');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Table = require('share/components/controls/DataGrid/Izenda.Table').Table;
  var Column = require('share/components/controls/DataGrid/Izenda.Table').Column;
  var Paginator = require('share/components/controls/DataGrid/helpers/Izenda.Paginator');
  var action = require('./Izenda.SystemVariablesAction');

  var TABLE_DEF = constants.TABLE_DEF;

  var SystemVariables = React.createClass({
    render: function () {
      var props = this.props;
      var store = props.store;
      var systemVariables = store.systemVariables;

      return (
        <GridLayout className='izenda-SystemVariables'>
          <GridLayout.Row>
            <GridLayout.Col cols='12'>
              <span className='u_textBold'>{constants.TITLE}</span>
              <hr />
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols='12'>
              <Label className=''>{constants.INSTRUCTION}</Label>
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols='12'>
              <Table dataSource={systemVariables.variables}
                onSortChange={props.onSortChange}
                sortInfo={systemVariables.pageInfo.colSortDirs}>

                {/* System Variable */}
                <Column {...TABLE_DEF['name']}
                  cell={this.renderName} />

                {/* Data Type */}
                <Column {...TABLE_DEF['dataType']}
                  cell={this.renderDataType} />

                {/* Description */}
                <Column {...TABLE_DEF['description']}
                  cell={this.renderDescription} />
              </Table>

              <Paginator onChange={store.goToSystemVariablesPage.bind(store) }
                onDropdownChange={store.onSystemVariablesPageSizeChange.bind(store) }
                totalRecords={systemVariables.pageInfo.totalRecords}
                pageSize={systemVariables.pageInfo.pageSize}
                pageIndex={systemVariables.pageInfo.pageIndex} />

            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      );
    },

    renderName: function (detail) {
      return (<span
        className="izenda-SystemVariables-linkable truncate overflow-text"
        title={detail.name}
        onClick={this.props.onSelect.bind(this, detail) }>
        {detail.name}
      </span>);
    },

    renderDataType: function (detail) {
      return (<span onClick={this.props.onSelect.bind(this, detail) }>{detail.dataType}</span>);
    },

    renderDescription: function (detail) {
      return (<span onClick={this.props.onSelect.bind(this, detail) }>{detail.description}</span>);
    }
  });

  module.exports = connect(action)(SystemVariables);
} ());



// WEBPACK FOOTER //
// ./ui/modules/Subscription/Izenda.SystemVariables.jsx